import { isEmpty } from "lodash";
import React from "react";
import { Header, Icon, Message } from "semantic-ui-react";
import { AcademicDetails } from "./academic-details";
import { Contact } from "./contact";
import { EUProjectParticipation } from "./eu-project-participation";
import { Expertise } from "./expertise";
import { RelevantProjects } from "./relevant-projects";
import { RelevantPublications } from "./relevant-publications";

export const ProfilePage = ({ userProfile = {} }) => {
    if (isEmpty(userProfile)) {
        return <Message size="big" color="violet" icon="privacy" content="This person has not yet completed their profile or their profile is private." />;
    }

    return (
        <>
            <Contact profile={userProfile} />
            <AcademicDetails profile={userProfile} />
            <Expertise profile={userProfile} />
            <EUProjectParticipation profile={userProfile} />
            <RelevantPublications profile={userProfile} />
            <RelevantProjects profile={userProfile} />
        </>
    );
};
